import { render, staticRenderFns } from "./SH051ShopperPointDetails.vue?vue&type=template&id=a52a7642&"
import script from "./SH051ShopperPointDetails.vue?vue&type=script&lang=js&"
export * from "./SH051ShopperPointDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports